import React from 'react';

import { useIntl } from 'react-intl';

import Avatar from '@atlaskit/avatar';
// eslint-disable-next-line @atlaskit/design-system/no-emotion-primitives -- to be migrated to @atlaskit/primitives/compiled – go/akcss
import { Inline, Stack, Text } from '@atlaskit/primitives/compiled';

import { type AgentDetailsWithAggData } from '../../../../../../controllers/agent-details/index.ts';
import { useTeamsController } from '../../../../../../controllers/teams/index.tsx';

import messages from './messages.ts';

type TeamsSectionProps = {
	agent: AgentDetailsWithAggData;
};

export const TeamsSection = ({ agent }: TeamsSectionProps): React.JSX.Element | null => {
	const { formatMessage } = useIntl();
	const { data, isFetching } = useTeamsController({
		userId: agent.identity_account_id,
	});

	if (isFetching) {
		return null;
	}

	if (!data || data.length === 0) {
		return <Text>{formatMessage(messages.noTeams)}</Text>;
	}

	return (
		<Stack space="space.050">
			{data.map(({ team, memberCount }) => (
				<Inline key={team.id} space="space.100">
					<Avatar name={team.displayName} href={team.smallAvatarImageUrl} />

					<Stack>
						<Text>{team.displayName}</Text>

						<Text size="small" color="color.text.subtlest">
							{formatMessage(messages.memberCount, { count: memberCount })}
						</Text>
					</Stack>
				</Inline>
			))}
		</Stack>
	);
};
